<template>
  <!--<section class="index">
    <div class="container">
      <div class="gc-page-container">
      <div class="container-center">
        <div class="shuomin">回答可获相应的点子数，累积兑换到零钱</div>
          <section class="gc-page" v-if="isShowBlankCard">
            <div class="noQ">
              <div class="noQ-div">
                  <p>哦呦，目前暂无适合您的现金问卷呢</p>
                  <p>但是有更加惊喜的问卷在等着您</p>
                  <p class="noQ-link">现金奖励即刻到账</p>
                  <p>24小时随时可以答题</p>
              </div>
              <div></div>
            </div>
          </section>
          <section class="gc-page" v-for="(item,index) in listData" :key="index">
            <template v-if="item.done">
              <div class="gc-headImg-ctx">
                <img class="gc-headImg" src="../assets/img/zhangdan@2x.png" />
              </div>
              <div class="gc-page-top done">
                <div class="ing-status"><span>{{ item.point }}</span>点</div>
              </div>
              <div class="gc-page-center">
                <p class="gc-nickname">{{ item.surveyId }}</p>
                <p class="gc-title">{{ item.surveyName }}</p>
                <p class="gc-subtitle">{{ item.surveyName }}</p>
              </div>
              <div class="gc-qrtime">创建时间：{{item.addTime}}</div>
              <div class="gc-qrcode">
                <div class="gc-qrcode-text" @click="onTapEnterBtn(index)">详情</div>
              </div>
            </template>
            <template v-else>
              <div class="gc-headImg-ctx">
                <img class="gc-headImg" src="../assets/img/WechatIMG16.jpeg" />
              </div>
              <div class="gc-page-top ing">
                <div class="ing-status"><span>{{ item.point }}</span>点</div>
              </div>
              <div class="gc-page-center">
                <p class="gc-nickname">{{ item.research_id }}</p>
                <p class="gc-title">{{ item.title }}</p>
                <p class="gc-subtitle">{{ item.title }}</p>
              </div>
              <div class="gc-qrtime">结束时间：{{item.arrivalDay}}</div>
              <div class="gc-qrcode">
                <div class="gc-qrcode-text" @click="onTapEnterBtn(index)">进入问卷</div>
              </div>
            </template>
          </section>
      </div>
      </div>
    </div>

    <card v-if="isShow" type="3" :dialog="dialog" @closeDialog="closeDialog"/>
  </section>-->
  <div class="tmp-contaniner">
    <div>频道更新  即将推出</div>
    <img src="../assets/img/coming.png" alt="">
  </div>
</template>

<script>
import Jsonp from 'jsonp';
import { getCookie } from '../utils';
import Card from '../components/DialogCard';

export default {
  components: {
    Card
  },
  data() {
    return {
      isShowBlankCard: false,
      listData: [],
      isShow: false,
      dialog: {}
    }
  },

  mounted() {
    // this.make();

  },

  methods: {
    make() {
      let unionId = getCookie('unionId');
      this.$axios.get('https://home.51point.com/51point-0.0.1-SNAPSHOT/completion/make3AttributeForPc', { params: { param: unionId }}).then(res => {
        console.log(res);
        this.request(res.data.data.attr, res.data.data.crpty);
      });
    },

    request(attr, crpty) {
      const url = 'https://pollon.infopanel.jp/pollon/jp/gmor/research/pollon/enqueteList/facade/EnqueteList.json' + '?panelType=89&crypt=' + crpty + '&attr=' + attr
      Jsonp(url, (err, data) => {
          console.log(data);
          if (!data || data.length == 0) {
            this.isShowBlankCard = true
          }

          let list = [];
          data.forEach(item => {
            let value = {};
            value.done = false;
            value.research_id = item.research_id;
            value.title = item.title;
            value.arrivalDay = item.arrivalDay;
            value.point = item.point;
            list.push(item);
          });
          this.listData = list;
          this.requestDone();
      })
    },

    requestDone() {
      let unionId = getCookie('unionId');
      this.$axios.get('https://home.51point.com/51point-0.0.1-SNAPSHOT/completion/completedQuestionnaireForPc', { params: { param: unionId}}).then(res => {
        console.log(res);
        let list = [];
        res.data.data.forEach(item => {
          let value = {};
          value.done = true;
          value.addTime = item.addTime;
          value.grantTimes = item.grantTimes;
          value.id = item.id;
          value.isAdd = item.isAdd;
          value.memberId = item.memberId;
          value.point = item.point;
          value.surveyId = item.surveyId;
          value.surveyName = item.surveyName;
          value.type = item.type;
          value.status = item.status;
          value.secId = item.secId;
          list.push(value);
        })
        this.listData = this.listData.concat(list);
      })
    },

    onTapEnterBtn(index) {
      let item = this.listData[index];
      console.log(item);
      if (item.done) {
        // 已完成
        this.$axios.get('https://home.51point.com/51point-0.0.1-SNAPSHOT/completion/completedQuestionnaireDetailForPc', { params: { secId: item.secId } }).then(res => {
          console.log(res);
          this.dialog =  res.data.data[0];
          this.isShow = true;
        })
      }else {
        // 进行中
        // window.open(item.redirectSt + item.id + '=' + item.encryptId);
        window.location.href = item.redirectSt + item.id + '=' + item.encryptId;
      }
    },

    closeDialog() {
      this.isShow = false;
    }
  }
}
</script>

<style scoped>

.tmp-contaniner {
  min-height: 540px;
  background: #f5f5f5;
  text-align: center;
  padding-top: 30px;
  font-size: 25px;
  color: #65AE71;
}

.tmp-contaniner img {
  width: 240px;
  height: 56.4px;
}

.index .gc-qrcode-img{
  width:125px;
  height:125px;
  margin: 20px auto;
}
.index .wxssk{
  font-size: 12px;
  color: #666666;
  text-align: center;
}
.index .gc-qrcode-ctx{
  width: 160px;
  height: 200px;
  background: #FFFFFF;
  border: 1px solid #EFEFEF;
  box-shadow: 0 2px 5px 0 rgba(0,0,0,0.08);
  border-radius: 2px;
}
.index .gc-qrcode{
  position: absolute;
  bottom: 20px;
  right: 15px;
}

.index .gc-qrtime {
  position: absolute;
  bottom: 20px;
  left: 15px;
  font-size: 10px;
  color: #999;
}
.index .gc-qrcode-text{
  font-size: 13px;
  color: #959499;
  border: 1px solid #d8d8d8;
  border-radius: 2px;
  /* width: 60px; */
  padding-left: 10px;
  padding-right: 10px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  float: right;
  margin-top: 10px;
  cursor: pointer;
}
.index .gc-qrcode-text:hover{
  background: #C9C9CE;
  border-color: #C9C9CE;
  color: #fff;
}
.index .gc-page{
  float:left;
  /* margin-right: 20px; */
  margin-left: 10px;
  margin-right: 10px;
}
.index .gc-category{
  position: absolute;
  right: 15px;
  top:15px;
  z-index: 2;
  border-radius: 100px;
  background-color: rgba(0,0,0,.7);
  font-size: 11px;
  color: #FFFFFF;
  padding:5px;
}
.index .gc-page-bottom{
  position: absolute;
  bottom: 20px;
  z-index: 2;
  left: 15px;
  height: 16px;
  line-height: 16px;
  width: 150px;
  font-size: 12px;
  color: #9B9B9B;
}
.index .gc-headImg-ctx{
  position: absolute;
  top: 125px;
  left: 15px;
  z-index: 2;
  width:32px;
  height:32px;
}
.index .gc-headImg{
  width:32px;
  height:32px;
  border-radius: 32px;
  border: 2px solid #FFFFFF;
}
.index .gc-page-top{
  width: 280px;
  height: 140px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.index .gc-page-center{
  position: relative;
  padding:15px;
  padding-top: 25px;
}
.index .gc-nickname{
  font-size: 13px;
  color: #666666;
  margin-bottom: 15px;
}
.index .gc-title{
  font-size: 15px;
  color: #333;
  margin-bottom: 12px;
  line-height: 22px;
}
.index .gc-subtitle{
  font-size: 12px;
  color: #888888;
  line-height: 18px;
  /* max-height: 54px; */
  overflow: hidden;
}
.index .gc-page{
  width: 280px;
  height: 360px;
  background: #FFFFFF;
  cursor: pointer;
  position: relative;
  margin-bottom: 20px;
}
.index .gc-page:hover{
  box-shadow: 0 10px 10px 0 rgba(0,0,0,0.08);
}
.index .container {
  min-height: 540px;
}

.index .gc-page-top img {
  width: 100%;
  height: 100%;
  background: gray;
}

.noQ {
	display: block;
	padding-top: 20px;
}

.noQ p {
	font-size: 14px;
	color: #666;
	text-align: center;
	line-height: 28px;
}

.noQ-div {
	width: 260px;
	height: 196.48px;
	margin: 0 auto;
	background-size: 360px 196.48px;
	padding-top: 22px;
	display: flex;
	flex-direction: column;
	align-items: center;
}

.noQ .noQ-link {
	color: #65AE71;
	border-bottom: 3px double #65AE71;
}

.noQ-btn {
	font-size: 16px;
	margin-top: 10px;
	color: white;
	/* background: #DF7F7D; */
	background:#65AE71;
	height: 40px;
	width: 120px;
	border-radius: 8px;
	display: flex;
	justify-content: center;
	align-items: center;
}

.noQ div:nth-of-type(2) {
	width: 47px;
	height: 77px;
	margin: 10px auto 0;
	background: url(../assets/img/zhanwuicon@2x.png) center no-repeat;
	background-size: 47px 77px;
}
.done {
  background: #9FC2E2;
}

.ing {
  background: #D4B7B5;
}

.done-status {
  position: relative;
  left: 100px;
  top: 118px;
  color: white;
}

.ing-status {
  position: relative;
  left: 100px;
  top:  110px;
  color: white;
}

.ing-status span {
  font-size: 160%;
  margin-right: 4px;
}

/*  */
.shuomin {
  color: #999;
  font-size: 14px;
  margin: 20px 0px;
  padding-left: 10px;
  width: calc(100% - 10px);
}

.gc-page-container {
	display: flex;
	flex-direction: row;
	justify-content: center;
	margin: 0 auto;
}

.index .container-center{
  margin:0 auto;
  overflow: hidden;
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	justify-content: flex-start;
}

/* 手机 */
@media screen and (max-width: 768px) {
	.index .container-center {
		width: 300px;
	}
}

/* Pad */
@media screen and (min-width: 768px) and (max-width: 1023px) {
	.index .container-center {
		width: 600px;
	}
}

/* 中屏幕电脑 */
@media screen and (min-width: 1024px) and (max-width: 1199px) {
	.index .container-center {
		width: 900px;
	}
}

/* 大屏幕电脑 */
@media screen and (min-width: 1200px) {
	.index .container-center {
		width: 1200px;
	}
}
</style>
